import { ISkill, IActiveSkill, IPassiveSkill } from "./ISkill";
import DoubleShotSkill from "./Active/DoubleShotSkill";
import PincerSkill from "./Active/PincerSkill";
import ExplodingArrowSkill from "./Active/ExplodingArrowSkill";
import SniperShotSkill from "./Active/SniperShotSkill";
import CriticalMasterySkill from "./Passive/CriticalMasterySkill";
import ManaRegenSkill from "./Passive/ManaRegenSkill";

export default class SkillRegistry {
  private static mAllSkills: ISkill[] = [];

  public static RegisterSkill(skill: ISkill): void {
    this.mAllSkills.push(skill);
  }

  public static GetSkill(name: string): ISkill | undefined {
    return this.mAllSkills.find((s) => s.Name === name);
  }

  public static GetAllSkills(): ISkill[] {
    return [...this.mAllSkills];
  }

  public static GetActiveSkills(): IActiveSkill[] {
    return this.mAllSkills.filter((s) => "Execute" in s) as IActiveSkill[];
  }

  public static GetPassiveSkills(): IPassiveSkill[] {
    return this.mAllSkills.filter(
      (s) => "ApplyBonus" in s && !("Execute" in s)
    ) as IPassiveSkill[];
  }

  public static PreloadAllIcons(scene: Phaser.Scene): void {
    this.GetActiveSkills().forEach((skill) => {
      scene.load.image(skill.IconKey, `images/skills/${skill.IconKey}.png`);
    });
  }
}

// Register all skills
SkillRegistry.RegisterSkill(new DoubleShotSkill());
SkillRegistry.RegisterSkill(new PincerSkill());
SkillRegistry.RegisterSkill(new ExplodingArrowSkill());
SkillRegistry.RegisterSkill(new SniperShotSkill());
SkillRegistry.RegisterSkill(new CriticalMasterySkill());
SkillRegistry.RegisterSkill(new ManaRegenSkill());
